import LoadingButton, { LoadingButtonProps } from "@mui/lab/LoadingButton";
import Box from "@mui/material/Box";
import type { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import type { FC, ReactNode } from "react";
import { PresenceDialog } from "./overlay-presence/presence-overlays";

export const Dialog: FC<{
	title?: ReactNode;
	content?: ReactNode;
	BeforeContent?: ReactNode | null;
	AfterContent?: ReactNode | null;
	secondaryActionButtonProps?: LoadingButtonProps;
	cancelButtonProps?: Omit<LoadingButtonProps, "variant" | "color">;
	actionButtonProps?: Omit<LoadingButtonProps, "variant">;
	dialogProps?: Omit<DialogProps, "open" | "scroll" | "fullWidth">;
}> = ({
	title,
	content,
	secondaryActionButtonProps,
	cancelButtonProps,
	actionButtonProps,
	BeforeContent = null,
	AfterContent = null,
	dialogProps,
}) => {
	return (
		<PresenceDialog
			maxWidth="lg"
			fullWidth
			open
			scroll="paper"
			{...dialogProps}>
			{!!title && <DialogTitle>{title}</DialogTitle>}
			{!!BeforeContent && <Box sx={{ px: 3 }}>{BeforeContent}</Box>}
			{!!content && <DialogContent>{content}</DialogContent>}
			{!!AfterContent && <Box sx={{ px: 3 }}>{AfterContent}</Box>}
			{(!!cancelButtonProps ||
				!!actionButtonProps ||
				!!secondaryActionButtonProps) && (
				<DialogActions sx={{ px: 3, py: 2 }}>
					<Stack
						flexGrow={1}
						direction="row"
						alignItems="center"
						gap={2}
						justifyContent={
							secondaryActionButtonProps ? "space-between" : "flex-end"
						}>
						{!!secondaryActionButtonProps && (
							<LoadingButton {...secondaryActionButtonProps}>
								{secondaryActionButtonProps.children}
							</LoadingButton>
						)}
						<Stack
							direction="row"
							gap={2}
							flexGrow={secondaryActionButtonProps ? 0 : 1}>
							{!!cancelButtonProps && (
								<LoadingButton
									{...cancelButtonProps}
									fullWidth={!secondaryActionButtonProps}
									variant="outlined"
									color="inherit">
									{cancelButtonProps.children}
								</LoadingButton>
							)}
							{!!actionButtonProps && (
								<LoadingButton
									{...actionButtonProps}
									fullWidth={!secondaryActionButtonProps}>
									{actionButtonProps.children}
								</LoadingButton>
							)}
						</Stack>
					</Stack>
				</DialogActions>
			)}
		</PresenceDialog>
	);
};
